import { useEffect } from "react";
import { Tab } from "@headlessui/react";
import classNames from "classnames";
import context from "lib/stores/context";
import mapData from "lib/stores/mapData";
import { useSnapshot } from "valtio";
import styles from "./index.module.scss";
import { ReactComponent as IconCloseDrawer } from "components/icons/close-panel.svg";

const SidebarTabs = () => {
  const { activeView, activeCountry, activeRegion, isCollapsed, activeTabWorldwide, activeTabCountries, activeTabRegions } =
    useSnapshot(context);
  const { showProducts } = useSnapshot(mapData);

  useEffect(() => {
    context.isCollapsed = true;
  }, [activeCountry, activeRegion]);

  const onClickTab = e => {
    const label = e.target.innerText;
    if (activeView === "worldwide" && context.isCollapsed) {
      if (label === "COUNTRIES") {
        if (activeTabWorldwide === 0) context.isCollapsed = false;
      }
      if (label === "REGIONS") {
        if (activeTabWorldwide === 1) context.isCollapsed = false;
      }
      if (label === "RESOURCES") {
        if (activeTabWorldwide === 2) context.isCollapsed = false;
      }
    }
    if (activeView === "region" && context.isCollapsed) {
      if (label === "COUNTRIES") {
        if (activeTabRegions === 0) context.isCollapsed = false;
      }
      if (label === "RESOURCES") {
        if (activeTabRegions === 1) context.isCollapsed = false;
      }
      if (label === "EXPLORE THE DATA") {
        if (activeTabRegions === 2) context.isCollapsed = false;
      }
    }
    if (activeView === "country" && context.isCollapsed) {
      if (label === "RECOMMENDATIONS") {
        if (activeTabCountries === 0) context.isCollapsed = false;
      }
      if (label === "RESOURCES") {
        if (activeTabCountries === 1) context.isCollapsed = false;
      }
      if (label === "EXPLORE THE DATA") {
        if (activeTabCountries === 2) context.isCollapsed = false;
      }
    }
  };

  const renderHidePanelsButton = () => {
    if (isCollapsed) return null;
    return (
      <div className={classNames(styles["hide-panels-button"], "md:flex hidden items-center justify-end flex-1")}>
        <button
          onClick={() => {
            context.isCollapsed = true;
          }}
          className="px-6 font-bold lg:text-base text-sm text-center flex items-center justify-center space-x-2"
        >
          <span className="inline-block">Close</span>
          <div className="icon-wrapper lg:w-[15px] w-[10px] font-normal">
            <IconCloseDrawer />
          </div>
        </button>
      </div>
    );
  };

  const renderTabs = () => {
    if (activeView === "worldwide") {
      return (
        <>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Countries
          </Tab>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Regions
          </Tab>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Resources
          </Tab>
          {renderHidePanelsButton()}
        </>
      );
    }
    if (activeView === "region") {
      return (
        <>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Countries
          </Tab>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Resources
          </Tab>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Explore the Data
          </Tab>
          {renderHidePanelsButton()}
        </>
      );
    }
    if (activeView === "country") {
      return (
        <>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Recommendations
          </Tab>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Resources
          </Tab>
          <Tab as="button" onClick={onClickTab} className={styles["sidebar-tab"]}>
            Explore the Data
          </Tab>
          {renderHidePanelsButton()}
        </>
      );
    }
  };

  return (
    <Tab.List
      id="sidebar-tabs"
      onChange={() => {
        mapData.showProducts = !showProducts;
      }}
      className={classNames(styles.list, isCollapsed ? "sidebar-is-collapsed" : "")}
    >
      {renderTabs()}
    </Tab.List>
  );
};

export default SidebarTabs;
